import { ApolloClient, InMemoryCache, ApolloLink, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { dhGetAuth } from 'helpers/Firebase';

import { createTokenExpiredLink } from 'helpers/tokenExpiredLink';

const httpLink = createHttpLink({
  uri: (req) => {
    return `${process.env.SELLER_HUB_CATALOG_GRAPHQL_API}/graphql?operationName=${req.operationName}&platform=sellerhub`;
  },
});
const authLink = setContext((_, { headers }) => {
  // it will always get unexpired version of the token
  try {
    return dhGetAuth()
      .currentUser.getIdToken()
      .then((token) => {
        window.localStorage.authToken = token;
        return {
          headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
          },
        };
      });
  } catch (e) {
    if (window.localStorage.authToken)
      return new Promise((resolve) => {
        resolve({
          headers: {
            ...headers,
            authorization: window.localStorage.authToken ? `Bearer ${window.localStorage.authToken}` : '',
          },
        });
      });
    return {};
  }
});
// const link = ApolloLink.from([authLink, ...{/**ur other links */}])
const tokenExpiredLink = createTokenExpiredLink({
  onRefreshed: (token) => {
    window.localStorage.authToken = token;
  },
});
const link = ApolloLink.from([authLink, tokenExpiredLink, httpLink]);

const ApolloClientCatalogService = new ApolloClient({
  link,
  // uri: 'http://localhost:4001/graphql',
  cache: new InMemoryCache({
    addTypename: false,
  }),
  // errorPolicy must live under defaultOptions - a top-level one is silently
  // dropped by the ApolloClient constructor, leaving queries on the default
  // 'none', where a single bad field discards the entire response payload.
  // Mutations stay on the default 'none' so failures keep rejecting/populating
  // `error`, which the detail screens rely on for their toasts.
  defaultOptions: {
    watchQuery: { errorPolicy: 'all' },
    query: { errorPolicy: 'all' },
  },
});
export default ApolloClientCatalogService;
